import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GeoLocationObject } from '../classes/geo-location-object';
import { GEO_LOCATION_TIMER } from '../common/constants';
// import { AssetService } from './asset.service';
import { LoggerService } from './logger.service';


@Injectable({
  providedIn: 'root'
})
export class GeoLocationService{

  private interval: ReturnType<typeof setInterval>;
  location = new GeoLocationObject();
  public location$: BehaviorSubject<GeoLocationObject> = new BehaviorSubject(null);

  constructor(
    // private assetService: AssetService,
    private logger: LoggerService) {}


  public startGeoLocation(): void{
    this.logger.info("Geo Location Started");
    this.getCurrentPosition();
    this.interval = setInterval(() => {
      this.getCurrentPosition();
    }, GEO_LOCATION_TIMER);
  }

  private stopGeoLocation(){
    if (this.interval) {
      clearInterval(this.interval);
      this.logger.info("geo location stopped");
    }
  }

  private getCurrentPosition() {
    if (window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          this.location.accuracy = position.coords.accuracy;
          this.location.altitude = position.coords.altitude;
          this.location.heading = position.coords.heading;
          this.location.latitude = position.coords.latitude;
          this.location.longitude = position.coords.longitude;
          this.location.speed = position.coords.speed;
          // this.assetService.updatePosition(this.location);  //send position to asset service
          this.location$.next(this.location);
        }, (error) => {
          this.logger.error('Geolocation error: '+ error);
        });
      } else {
        this.logger.error('Geolocation not supported in this browser');
      }
  }

  ngOnDestroy(): void {
    this.stopGeoLocation();
  }

}
